import { useEffect, useRef } from "react";

/**
 * AdSense responsive slot for the home page (under the game icons).
 * Slot ID: 6603519116
 */
export default function HomeAdSense() {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {}
  }, []);

  return (
    <div className="relative z-10 w-full max-w-3xl mx-auto px-4 mt-8">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-9843677136046770"
        data-ad-slot="6603519116"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
